import Global from './Global';

const Routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "ICT" */ '@/pages/Home/Home.vue'),
		meta: {
			title: 'Home',
			auth: true,
		},
	},
	{
		path: '/quotes',
		name: 'quotes',
		component: () => import(/* webpackChunkName: "ICT" */ '@/pages/Quotes/Quotes.vue'),
		meta: {
			title: 'Quotes',
			auth: true,
		},
	},
	{
		path: '/quotes-list',
		name: 'quotesList',
		component: () => import(/* webpackChunkName: "ICT" */ '@/pages/Quotes/BrokerQuotes.vue'),
		meta: {
			title: 'QuotesList',
			auth: true,
		},
	},
	{
		path: '/clients-list',
		name: 'BrokerClientsList',
		component: () => import(/* webpackChunkName: "ICT" */ '@/pages/Broker/BrokerClients.vue'),
		meta: {
			title: 'ClientsList',
			auth: true,
		},
	},
	{
		path: '/client-details',
		name: 'BrokerClientDetails',
		component: () =>
			import(/* webpackChunkName: "ICT" */ '@/pages/Broker/BrokerClientDetails.vue'),
		meta: {
			title: 'ClientDetails',
			auth: true,
		},
	},
	{
		path: '/quote-details',
		name: 'BrokerQuoteDetails',
		component: () =>
			import(/* webpackChunkName: "ICT" */ '@/pages/Quotes/BrokerQuoteDetails.vue'),
		meta: {
			title: 'quote-details',
			auth: true,
		},
	},
	{
		path: '/claims/submit',
		name: 'submitclaim',
		component: () =>
			import(/* webpackChunkName: "ICT" */ '@/pages/Claims/InsureCareTeams/SubmitClaim.vue'),
		meta: {
			title: 'Submit Claim',
			auth: true,
		},
	},
	{
		path: '/claims',
		name: 'claims',
		component: () =>
			import(/* webpackChunkName: "ICT" */ '@/pages/Claims/InsureCareTeams/Claims.vue'),
		meta: {
			title: 'Claims',
			auth: true,
		},
	},
	{
		path: '/claims/thankyou',
		name: 'claimThankYou',
		component: () =>
			import(
				// @ts-ignore
				/* webpackChunkName: "ICT" */ '@/pages/Claims/InsureCareTeams/ThankYouSubmission.vue'
			),
		meta: {
			title: 'Claim Submission - Thank You',
			auth: true,
		},
	},
	{
		path: '/payment',
		name: 'payment',
		component: () => import(/* webpackChunkName: "ICT" */ '@/pages/BillPay/PayBill.vue'),
		meta: {
			title: 'Pay My Bill',
			auth: true,
		},
	},
	{
		path: '/payment/methods',
		name: 'paymentmethods',
		component: () => import(/* webpackChunkName: "ICT" */ '@/pages/BillPay/PaymentMethods.vue'),
		meta: {
			title: 'Payment Methods',
			auth: true,
		},
	},
	{
		path: '/brokerage/*',
		name: 'brokerage',
		component: () =>
			import(/* webpackChunkName: "ICT" */ '@/pages/RegistrationFlow/SignInRegister.vue'),
	},
	...Global,
];

export default Routes;
